(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    'use strict';
    var root = document.querySelector('[data-u-root="trojki"]');
    var ui = window.PEWNIAKI_UI_TROJKI;
    if (!root || !ui) return;

    root.dataset.gra = __pewniaki_inline_cfg[0];

    var el = document.querySelector('script[type="application/json"][data-page-report]');
    var dane = null;
    try { dane = el ? JSON.parse(el.textContent) : null; } catch (e) { dane = null; }

    // Dane osadzone w HTML są tylko rankingiem. Wyszukiwanie dowolnej trójki
    // uruchamia się dopiero po pobraniu pełnej mapy przez analiza.js.
    var start = null;

    var ctrl = ui.steruj(root, { gra: __pewniaki_inline_cfg[3], pool: JSON.parse(String(__pewniaki_inline_cfg[4])), start: start });

    if (!dane) { ctrl.onError(); return; }

    window.PEWNIAKI_ANALIZA = {
        plik: '/assets/json/db/' + __pewniaki_inline_cfg[5] + '/analizy/trojki.json',
        plikStart: dane.skrot ? '/assets/json/db/' + __pewniaki_inline_cfg[5] + '/analizy/trojki-skrot.json' : null,
        oknoPlik: dane.skrot ? '/assets/json/db/' + __pewniaki_inline_cfg[5] + '/analizy/trojki-okna/' : null,
        wersja: dane.policzono || '',
        render: ctrl.render,
        wnioski: ctrl.wnioski,
        onError: ctrl.onError
    };
})();
})();
